import Logo from "./Logo"
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Menu from "./Menu";
import { useState } from "react";

export default function Header({tab, menu}){

    const [display, setDisplay] = useState(false)

    return <header className='layout-header'>

        <div className='layout-header-content'>

            <Logo />

            <div onClick={() => setDisplay(!display)}>
                {display ? <CloseIcon fontSize='large'/> : <MenuIcon fontSize='large'/>}
            </div>
            
        </div>
        
        {display && <Menu tab={tab} menu={menu} />}
    </header>
}